import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Stack, Table, Text } from "@mantine/core";
import { SendOutlined } from "@mui/icons-material";
import { getRelativeTimeFromDate } from "../../utils/Date.utils";
import { ActionsMenu } from "../../shared/ActionsMenu";
import { PriorityInviteChip } from "./PriorityInviteChip";
import { EmailLinkWithIcon } from "../../shared/ContactInfo";
import { ImageWithPlaceholder } from "../../shared/ImageWithPlaceholder";
export const PriorityInviteRow = ({ priorityInvite, onResendInvite, onDeleteInvite }) => {
    // Menu
    const actionsMenuItems = [
        {
            icon: SendOutlined,
            text: "Resend Invite",
            onClick: onResendInvite
        }
    ];
    // Data
    const invitingUser = priorityInvite?.invitingUser;
    return (_jsxs(Table.Tr, { children: [_jsx(Table.Td, { children: _jsxs(Flex, { align: "center", gap: "xs", children: [_jsx(ImageWithPlaceholder, { imageUrl: invitingUser?.imageUrl, avatarText: invitingUser?.name, size: 25 }), _jsxs(Stack, { gap: 0, children: [_jsx(Text, { variant: "body-strong", children: invitingUser?.name }), _jsx(Text, { variant: "meta", children: invitingUser?.email })] })] }) }), _jsx(Table.Td, { children: _jsx(EmailLinkWithIcon, { justify: "flex-start", email: priorityInvite?.email }) }), _jsx(Table.Td, { children: _jsx(PriorityInviteChip, { acceptedAt: priorityInvite?.acceptedAt, updatedAt: priorityInvite?.updatedAt }) }), _jsx(Table.Td, { children: priorityInvite?.createdAt
                    ? getRelativeTimeFromDate(priorityInvite?.createdAt)
                    : "-" }), _jsx(Table.Td, { children: _jsx(ActionsMenu, { entityId: priorityInvite?.priorityInviteId ?? "", menuOptions: actionsMenuItems, allowDelete: true, handleDelete: () => onDeleteInvite() }) })] }));
};
